import * as React from 'react';

import FileIllustrator32 from './FileIllustrator32';

export const fileIllustrator32 = () => <FileIllustrator32 />;

export default {
    title: 'Icon|Content|FileIllustrator32',
    component: FileIllustrator32,
    parameters: {
        notes: "`import FileIllustrator32 from 'box-ui-elements/es/icon/content/FileIllustrator32';`",
    },
};
